import React, { useState } from 'react'
import Title from './components/Title/Title'
import './App.scss'
import logo from './assets/logosnowcamp.png'
import Button from './components/Button/Button'
import { Navigate } from 'react-router-dom'
import { FaWhatsapp } from 'react-icons/fa';
import Info from './components/Info/Info'

const App = () => {
  const now = new Date();
  const [signUp, setSignUp] = useState(false);

  return (
    <div className='container'>
      {/* <img src={logo} alt="" /> */}
      {/* {signUp && <Navigate to="/signup" />} */}
      <div className='closedIscritions'>
        le iscrizioni sono chiuse ma puoi sempre contattarci per aggiungerti alla lista d'attesa
      </div>
      <Title>snowcamp {now.getFullYear()}</Title>
      <label className='subtitle'>HOTEL LIBIA - FINO DEL MONTE (BG)</label>
      <label className='subtitle'>Dal 29 Dicembre {now.getFullYear()} al 2 Gennaio {now.getFullYear() + 1} </label>
      <div className='buttons-container'>
        {/* <Button onClick={() => setSignUp(true)}>Iscriviti Ora!</Button> */}
        <div className='contacts'>
          <FaWhatsapp /> Franco Deriu <a href='tel:+39 3281612303'>328 1612303</a>
        </div>
        <div className='contacts'>
          <FaWhatsapp /> Fabio Milone <a href='tel:+39 3478738291'> 347 8738291</a>
        </div>
        <Info />
      </div>
    </div>
  )
}

export default App